// extracted by mini-css-extract-plugin
export default {"active":"ProjectStepper_active__-n7RL","line":"ProjectStepper_line__FVQ7a","completed":"ProjectStepper_completed__of5X1","finalStep":"ProjectStepper_finalStep__CDOEh"};